<script setup lang="ts">
/** Certificate of Exempt Private Company (Section 260) — M32016 */
import EpcDocVarField from './EpcDocVarField.vue';
</script>

<template>
  <div class="epc-doc">
    <div class="doc-head">
      <div class="doc-meta">COMPANIES ACT 2016</div>
      <div class="doc-meta">Section 260</div>
      <div class="doc-company" style="font-size:13px; margin-top:6px">
        LODGEMENT OF CERTIFICATE RELATING TO AN EXEMPT PRIVATE COMPANY
      </div>
      <div class="doc-company" style="margin-top:10px">
        <EpcDocVarField field-key="company_name" />
      </div>
    </div>

    <p class="doc-lbl-title">CERTIFICATION OF STATUS</p>
    <p class="doc-p">We hereby confirm that:</p>
    <ul class="epc-bullets">
      <li>the company is and has at all relevant times been an exempt private company;</li>
      <li>
        a duly audited financial statements and reports required under this Act made up to the
        <EpcDocVarField field-key="fs_made_up_to" />
        has been circulated to its members on
        <EpcDocVarField field-key="circulation_date" />; and
      </li>
      <li>
        as at the date to which the financial statements has been made up, the company appeared to have able to meet its liabilities as and when the liabilities fall due.
      </li>
    </ul>

    <p class="doc-p" style="margin-top:14px"><b>Date:</b> <EpcDocVarField field-key="certification_date" /></p>

    <p class="doc-lbl-title">SIGNATORY(S) TO THE CONFIRMATION OF STATUS</p>

    <div class="sig-block">
      <div class="sig-role">Director:</div>
      <div class="sig-line">________________________________________________</div>
      <div class="doc-p"><b>Name:</b> <EpcDocVarField field-key="director_name" /></div>
    </div>

    <div class="sig-block">
      <div class="sig-role">Secretary:</div>
      <div class="sig-line">________________________________________________</div>
      <div class="doc-p"><b>Name:</b> <EpcDocVarField field-key="secretary_name" /></div>
      <div class="doc-p"><b>License No./ Membership No.:</b> <EpcDocVarField field-key="secretary_license_no" /></div>
      <div class="doc-p"><b>Practicing Certificate No.:</b> <EpcDocVarField field-key="secretary_practicing_cert_no" /></div>
    </div>

    <div class="sig-block">
      <div class="sig-role">Auditors:</div>
      <div class="sig-line">________________________________________________</div>
      <div class="doc-p"><b>Name of Audit Firm:</b> <EpcDocVarField field-key="audit_firm_name" /></div>
      <div class="doc-p"><b>Audit Firm Number:</b> <EpcDocVarField field-key="audit_firm_number" /></div>
      <div class="sig-line" style="margin-top:10px">________________________________________________</div>
      <div class="doc-p"><b>(Partner) Name of auditors:</b> <EpcDocVarField field-key="auditor_name" /></div>
      <div class="doc-p"><b>Audit License Number:</b> <EpcDocVarField field-key="audit_license_no" /></div>
    </div>

    <p class="doc-lbl-title">DECLARATION</p>
    <p class="doc-p">
      I confirm that the facts and information stated in this document are true and to the best of my knowledge.
    </p>
    <div class="sig-block">
      <div class="sig-line">________________________________________________</div>
      <div class="sig-role">Secretary</div>
      <div class="doc-p"><b>Name:</b> <EpcDocVarField field-key="secretary_name" /></div>
      <div class="doc-p"><b>License No./ Membership No.:</b> <EpcDocVarField field-key="secretary_license_no" /></div>
      <div class="doc-p"><b>Practicing Certificate No.:</b> <EpcDocVarField field-key="secretary_practicing_cert_no" /></div>
      <div class="doc-p"><b>Date:</b> <EpcDocVarField field-key="declaration_date" /></div>
    </div>

    <div class="doc-attn">
      <b>Attention:</b>
      It is an offence under section 591 of the Companies Act 2016 to make or authorize the making of a statement
      that a person knows is false or misleading and that person may be liable, upon conviction, to imprisonment
      for a term not exceeding ten years or to a fine not exceeding RM3million or to both.
    </div>

    <p class="doc-lbl-title">LODGER INFORMATION</p>
    <table class="cdd-tbl epc-lodger">
      <colgroup>
        <col style="width:32%" />
        <col style="width:68%" />
      </colgroup>
      <tbody>
        <tr>
          <td class="cdd-lcell">Name</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_name" placeholder="Name" /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">NRIC No</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_nric" placeholder="NRIC No." /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Address</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_address" placeholder="Address" /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Phone No</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_phone" placeholder="Phone No." /></div></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Email</td>
          <td><div class="cell-field"><EpcDocVarField field-key="lodger_email" placeholder="Email" /></div></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style src="./epcDoc.css"></style>
<style scoped>
.epc-lodger .cell-field :deep(.epcf) {
  display: flex !important;
  width: 100%;
  max-width: 100%;
}
.epc-lodger .cell-field :deep(.epcf-in) {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
